// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StepBackwardFilledSvg from "@fishx/icons-svg/es/asn/StepBackwardFilled";
import FishxIcon from '../components/FishxIcon';

var StepBackwardFilled = function StepBackwardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StepBackwardFilledSvg
  }));
};

StepBackwardFilled.displayName = 'StepBackwardFilled';
export default React.forwardRef(StepBackwardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StepBackwardFilled.js
// module id = 4192
// module chunks = 0